import { categorizeFields } from './FieldCategories.js'
import type { MetadataFields } from '../../MetadataFields.js'
import { type MetadataFieldDescriptor } from '../../MetadataFields.js'
import { useMemo } from 'react'
import type { VisualizationSampleContainer } from '../../VisualizationSampleContainer.js'

export function MetadataFieldSelect({
  value,
  onChange,
  samples,
  label = 'Select field',
  allowedTypes,
  metadataFields,
  disabled = false
}: {
  value: string
  onChange: (fieldKey: string) => void
  samples: VisualizationSampleContainer[]
  label?: string
  allowedTypes?: string[]
  metadataFields: MetadataFields
  disabled?: boolean
}) {
  const categorized = useMemo(() => categorizeFields(metadataFields, samples), [samples])

  const filterByType = (entries: Record<string, MetadataFieldDescriptor>) =>
    Object.entries(entries).filter(([, desc]) => !allowedTypes || allowedTypes.includes(desc.type))

  return (
    <select className="select select-sm select-bordered" value={value} onChange={(e) => onChange(e.target.value)} disabled={disabled}>
      <option disabled value="">
        {label}
      </option>

      {filterByType(categorized.other).map(([key, desc]) => (
        <option key={key} value={key}>
          {desc.label}
        </option>
      ))}

      {filterByType(categorized.singleValued).map(([key, desc]) => (
        <option key={`single-${key}`} value={key} disabled>
          {desc.label} (single value)
        </option>
      ))}

      {filterByType(categorized.unused).map(([key, desc]) => (
        <option key={`unused-${key}`} value={key} disabled>
          {desc.label} (no data)
        </option>
      ))}
    </select>
  )
}
